import { createIcon } from '@chakra-ui/icons';

export const MultipleChoice = createIcon({
  displayName: 'MultipleChoice',
  viewBox: '0 0 24 25',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <g clipPath="url(#clip0_454_5064)">
        <path
          d="M24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5C18.6274 24.5 24 19.1274 24 12.5Z"
          fill="#FDE9C8"
        />
        <g clipPath="url(#clip1_454_5064)">
          <path
            d="M7.875 10C8.56536 10 9.125 9.44036 9.125 8.75C9.125 8.05964 8.56536 7.5 7.875 7.5C7.18464 7.5 6.625 8.05964 6.625 8.75C6.625 9.44036 7.18464 10 7.875 10Z"
            fill="#977334"
          />
          <path d="M16.625 8.125H10.375V9.375H16.625V8.125Z" fill="#977334" />
          <path
            d="M7.875 13.75C8.56536 13.75 9.125 13.1904 9.125 12.5C9.125 11.8096 8.56536 11.25 7.875 11.25C7.18464 11.25 6.625 11.8096 6.625 12.5C6.625 13.1904 7.18464 13.75 7.875 13.75Z"
            fill="#977334"
          />
          <path d="M16.625 11.875H10.375V13.125H16.625V11.875Z" fill="#977334" />
          <path
            d="M7.875 17.5C8.56536 17.5 9.125 16.9404 9.125 16.25C9.125 15.5596 8.56536 15 7.875 15C7.18464 15 6.625 15.5596 6.625 16.25C6.625 16.9404 7.18464 17.5 7.875 17.5Z"
            fill="#977334"
          />
          <path d="M16.625 15.625H10.375V16.875H16.625V15.625Z" fill="#977334" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_454_5064">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
        <clipPath id="clip1_454_5064">
          <rect width="10" height="10" fill="white" transform="translate(6.625 7.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
